import { FiShoppingCart } from "react-icons/fi";
import tumnail from "../assets/img/slide/Allustration.png";
import tumnail1 from "../assets/img/slide/Group 3.png";
import tumnail2 from "../assets/img/slide/slide-3.png";
import Blog from "./Menu";
import { useState, useEffect } from "react";
import FoodCard from "./FoodCard";
import Special from "./Special";
import Place from "./Place";
import Review from "./Review";
import Contact from "./Contact";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
// import SliderFood from "./SliderFood";

const HomePage = () => {
  const { t } = useTranslation("homePage");
  const navigate = useNavigate();
  const images = [tumnail, tumnail1, tumnail2];
  const [current, setCurrent] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [images.length]);
  return (
    <>
      <section className="flex flex-col md:flex-col lg:flex-row items-center justify-between px-4 sm:px-6 lg:px-12 max-w-screen-2xl mx-auto min-h-[80vh] pt-20 pb-10">
        {/* Image Section */}
        <div className="w-full lg:w-1/2 flex justify-center items-center mx-auto sm:mb-4 mb-10 lg:mb-0 mt-20 lg:mt-0 relative" data-aos="fade-left" data-aos-duration="1000">
          <div
            className="
      relative
      w-full
      max-w-sm sm:max-w-md md:max-w-lg lg:max-w-xl
      aspect-square sm:aspect-[4/3] md:aspect-[5/4] lg:aspect-[4/3]
      rounded-2xl overflow-hidden
    "
          >
            {images.map((img, index) => (
              <img
                key={index}
                src={img}
                alt={`Slide ${index + 1}`}
                className={`
          absolute inset-0 w-full h-full
          object-contain
          transition-opacity duration-1000 ease-in-out
          ${index === current ? "opacity-100 z-10" : "opacity-0 z-0"}
        `}
              />
            ))}
          </div>
        </div>

        {/* Text Section */}
        <div className="w-full lg:w-1/2 px-2 sm:px-4 md:px-6 lg:px-10 text-center lg:text-left mt-6 lg:mt-0 order-first md:order-first lg:order-last z-10" data-aos="fade-right" data-aos-duration="1000">
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-4 md:mb-6 text-coffee-dark tracking-tight">
            {t("headline_line1")} <br />
            <span className="text-accent-gold">{t("headline_line2")}</span>
          </h1>

          <p className="text-coffee-medium mb-8 text-sm sm:text-base md:text-lg leading-relaxed max-w-2xl mx-auto lg:mx-0">
            {t("description")}
          </p>

          <div className="flex flex-wrap items-center justify-center sm:justify-start gap-4 text-center mb-4">
            <button
              onClick={() => navigate("/menu")}
              className="flex items-center gap-2 bg-accent-gold text-coffee-dark font-semibold px-8 py-3 rounded-full hover:bg-yellow-400 hover:shadow-glow transform hover:-translate-y-1 transition-all duration-300 text-sm sm:text-base"
            >
              {t("order_now")}{" "}
              <FiShoppingCart className="text-sm sm:text-base" />
            </button>

            <button
              onClick={() => navigate("/about")}
              className="px-8 py-3 border-2 border-accent-gold text-accent-gold font-semibold rounded-full hover:bg-accent-gold hover:text-coffee-dark transform hover:-translate-y-1 transition-all duration-300 text-sm sm:text-base"
            >
              {t("learn_more")}
            </button>
          </div>
        </div>
      </section>

      {/* Blog Section */}
      <div>
        <Blog />
      </div>
      <div>
        <FoodCard />
      </div>
      <div>
        <Special />
      </div>
      <div>
        <Place />
      </div>
      <div>
        <Review />
      </div>
      {/* <div>
        <SliderFood />
      </div> */}
      <div>
        <Contact />
      </div>
    </>
  );
};
export default HomePage;
